// MEDIA
export const CREATE_ANNOTATION = 'CREATE_ANNOTATION';
export const UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
export const DELETE_ANNOTATION = 'DELETE_ANNOTATION';
export const SELECT_ANNOTATION = 'SELECT_ANNOTATION';

export const UNSELECT_ANNOTATION = 'UNSELECT_ANNOTATION';
